﻿<script>
    import AlphaNumericInput from "./AlphaNumericInput.svelte";

    export let disabled = null;
	export let required = null;
	export let label = "What is the VIN number of your vehicle?"
	export let sublabel = null;
	export let value;
	export let patternValidator = "(JT|6T|SB|MR|7A4|jt|6t|sb|mr|7a4).+";
	export let dataBouncerMessage = "Unfortunately you are ineligible for the action. Effected vehicle VINs start with JT, 6T, SB, MR or 7A4.";

    let tooltipText = `<p>Your unique VIN can be found in the following locations:</p>
<p>
<b>On your vehicle body</b><br>
The Vehicle Compliance label can be seen on the driver's or passenger's side door jamb or is stamped into the floor in front of the driver's side seat.
</p>
<p>
<b>Your vehicle documentation</b><br>
Your VIN can be found printed on your registration certificate or retail delivery card which may be found in your vehicle Service & Warranty booklet.
</p>
<p>
<b>Owner's manual</b><br>
Look for 'Vehicle Identification Number' in the index at the back of your Owner's manual.
</p>
`
</script>

<AlphaNumericInput {required}
            {disabled}
            {label}
            {sublabel}
            bind:value={value}
            errorMessageTarget=".vin-error"
            {patternValidator}
            {dataBouncerMessage}
            {tooltipText}
></AlphaNumericInput>
<div class="vin-error"></div>
